import { parse } from '@loaders.gl/core';
import type { Loader, LoaderOptions } from '@loaders.gl/loader-utils';
import { toast } from '@raystack/apsara';

import { CORRELATION_ID_HEADER, CURRENT_ORG_HEADER } from './constants/APP';
import { generateRequestId } from './requestId';

class CustomFetch {
  // eslint-disable-next-line no-use-before-define
  private static instance: CustomFetch;
  private orgId!: string;
  private constructor() {}

  public static getInstance() {
    if (!this.instance) {
      this.instance = new CustomFetch();
    }
    return this.instance;
  }

  public setOrg(orgId: string) {
    this.orgId = orgId;
  }

  public getOrg(): string {
    return this.orgId;
  }

  public fetch(
    input: RequestInfo | URL,
    init: RequestInit = {}
  ): Promise<Response> {
    return fetch(input, {
      ...init,
      headers: {
        ...(init?.headers || {}),
        [CURRENT_ORG_HEADER]: CustomFetch.getInstance().getOrg(),
        [CORRELATION_ID_HEADER]: generateRequestId()
      },
      credentials: 'include'
    });
  }

  public async fetchTile(
    url: string,
    {
      loadOptions,
      signal,
      loaders
    }: {
      loaders?: Loader[];
      loadOptions?: LoaderOptions;
      signal?: AbortSignal;
    }
  ) {
    try {
      const response = await fetch(url, {
        signal,
        headers: {
          [CURRENT_ORG_HEADER]: CustomFetch.getInstance().getOrg(),
          [CORRELATION_ID_HEADER]: generateRequestId()
        },
        credentials: 'include'
      });
      if (!response.ok) {
        if (response.status === 400) {
          toast.error('Invalid Input!', {
            description:
              'The input expression is invalid. Please enter a valid expression and try again.'
          });
          return null;
        }
        if (response.status === 404) {
          return null;
        }
        if (response.status === 403) {
          toast.warning('Access Not Available!', {
            description:
              'Please contact Customer Success team (support@pixxel.space) to get access to this image'
          });
          return null;
        }
      }

      return parse(response, loaders, loadOptions);
    } catch (error) {
      // removes this as it clutters sentry logs - this is generally triggered when ui actions are performed extremely fast or the map is unmounted quickly
      // console.error(error);
      return null;
    }
  }
}

export const customFetch = CustomFetch.getInstance();
